import firebaseApp from '@/lib/firebase/app';
import type { FirebaseApp } from 'firebase/app';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

const getFirebaseLocalCache = () => {
  return initializeFirestore(firebaseApp as FirebaseApp, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
};

// biome-ignore lint/suspicious/noExplicitAny: firebaseApp is null when not initialized; cast needed for getFirestore overload
export const firestoreDB = firebaseApp ? getFirebaseLocalCache() : getFirestore(firebaseApp as any);
